import moment from "moment";
import store from "../../../../store";
import Flowit from "../../../../services/flowit";
import * as types from "./types";

export const updateOrdination = ({ commit }, newOrdination) => {
  commit(types.ORDINATION, newOrdination);
};

export const setLoadingData = ({ commit }, status) => {
  commit(types.LOADING_DATA, status);
};

export const setLimit = ({ commit }, limit) => {
  commit(types.LIMIT, limit);
};
export const setCurrentPage = ({ commit }, page) => {
  commit(types.CURRENT_PAGE, page);
};

export const showFilters = ({ commit }, param) => {
  commit(types.SHOW_FILTERS, param);
};

export const setStartAt = ({ commit }, param) => {
  store.state.wallet.filterParams.filterrific.with_created_at_between.start_at = param;
};

export const newBillPayment = ({ commit }, billPayment) => {
  commit(types.LOADING_DATA, true);
  Flowit.wallet
    .newBillPayment(billPayment)
    .then(response => {
      commit(types.SET_BILL_PAYMENT, response);
      commit(types.LOADING_DATA, false);
    })
    .catch(error => {
      let errorData = {};
      
      // Tratar especificamente erro 403 (forbidden) - funcionalidade desabilitada
      if (error.response && error.response.status === 403) {
        errorData = {
          errors: [{
            response_code: "403",
            response_code_detail: "Sistema de pagamento de contas desabilitado. Entre em contato com seu representante para ativar esta funcionalidade."
          }]
        };
      } else if (error.response && error.response.data) {
        // Usar dados de erro do backend se disponível
        errorData = error.response.data;
      } else {
        // Fallback para erro genérico
        errorData = {
          errors: [{
            response_code: "500",
            response_code_detail: error.message || "Erro ao processar pagamento de conta"
          }]
        };
      }
      
      commit(types.SET_BILL_PAYMENT_ERRORS, errorData);
      commit(types.LOADING_DATA, false);
    });
};

export const showBillPayment = ({ commit }, showBillPayment) => {
  commit(types.LOADING_DATA, true);
  Flowit.wallet.showBillPayment(showBillPayment).then(response => {
    if (response.status === 200) {
      commit(types.SHOW_BILL_PAYMENT, response.data.bill);
    } else {
      commit(types.SET_BILL_PAYMENT_ERRORS, response.data);
    }
  });
};

export const showBillPayments = ({ commit }, showBillPayments) => {
  commit(types.LOADING_DATA, true);
  Flowit.wallet.showBillPayments(showBillPayments).then(response => {
    if (response.status === 200) {
      commit(types.SHOW_BILL_PAYMENTS, response.data.bill_payment);
    } else {
      commit(types.SET_BILL_PAYMENT_ERRORS, response.data);
    }
    commit(types.LOADING_DATA, false);
  }).catch(error => {
    commit(types.SET_BILL_PAYMENT_ERRORS, error);
    commit(types.LOADING_DATA, false);
  });
};

export const loadBills = ({ commit }, params) => {
  commit(types.SET_BILL_LOADING_DATA, true);
  Flowit.wallet.billsList(params)
    .then(response => {
      commit(types.SET_BILL_RESOURCES, response.data.resources || []);
      commit(types.SET_BILL_RESOURCES_COUNT, response.data.count || 0);
      commit(types.SET_BILL_LOADING_DATA, false);
    })
    .catch(error => {
      console.error('Error loading bills:', error);
      commit(types.SET_BILL_RESOURCES, []);
      commit(types.SET_BILL_RESOURCES_COUNT, 0);
      commit(types.SET_BILL_LOADING_DATA, false);
    });
};

export const loadBillsPayment = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  Flowit.wallet.billsPaymentList(params).then(response => {
    commit(types.SET_BILL_PAYMENT_RESOURCES, response.data.resources);
    commit(types.SET_BILL_PAYMENT_RESOURCES_COUNT, response.data.count);
    commit(types.CURRENT_PAGE, response.data.page);
    commit(types.CURRENT_PAGE, response.data.limit);
    commit(types.SET_BILL_PAYMENT_LOADING_DATA, false);
  });
};

export const downloadPdf = ({ commit }, billId) => {
  return Flowit.wallet
    .downloadBillPdf(billId)
    .then(response => {
      if (response.status === 200) {
        return { success: true, data: response.data };
      } else {
        return { success: false, error: 'Erro ao baixar PDF' };
      }
    })
    .catch(error => {
      console.error('Error downloading PDF:', error);
      return { success: false, error: 'Erro ao baixar PDF' };
    });
};

export const checkBillStatus = ({ commit }, params) => {
  return Flowit.wallet
    .checkBillStatus(params)
    .then(response => {
      if (response.status === 200) {
        // Atualizar o bill no store com os dados mais recentes
        commit(types.SHOW_BILL_PAYMENT, response.data.bill);
        return { success: true, data: response.data };
      } else {
        return { success: false, error: 'Erro ao verificar status' };
      }
    })
    .catch(error => {
      console.error('Error checking bill status:', error);
      return { success: false, error: 'Erro ao verificar status' };
    });
};

export const slipRecharge = ({ commit }, bill) => {
  commit(types.LOADING_DATA, true);
  Flowit.wallet
    .slipRecharge(bill)
    .then(response => {
      if (response.status === 201) {
        commit(types.SET_URL_BILL, response.data);
      } else {
        commit(types.SET_BILL_ERROS, response.data);
      }
    })
    .catch(error => {
      let errors = {};
      
      // Tratar especificamente erro 403 (forbidden) - funcionalidade desabilitada
      if (error.response && error.response.status === 403) {
        errors = { 
          desenvolvedor: { 
            mensagem: "Sistema de geração de boletos desabilitado. Entre em contato com seu representante para ativar esta funcionalidade." 
          } 
        };
      } else if (error.response && error.response.data && error.response.data.error) {
        // Usar mensagem de erro do backend se disponível
        errors = { desenvolvedor: { mensagem: error.response.data.error } };
      } else {
        // Fallback para erro genérico
        errors = { desenvolvedor: { mensagem: error.message || "Erro ao gerar boleto" } };
      }
      
      commit(types.SET_BILL_ERROS, errors);
    });
};

export const selfSlipRecharge = ({ commit }, bill) => {
  commit(types.LOADING_DATA, true);
  Flowit.wallet
    .selfSlipRecharge(bill)
    .then(response => {
      if (response.status === 201) {
        commit(types.SET_URL_BILL, response.data);
        // console.log(types.SET_URL_BILL, response.data);
      } else {
        commit(types.SET_BILL_ERROS, response.data);
        // console.log(types.SET_URL_BILL, response.data);
      }
    })
    .catch(error => {
      let errors = {};
      
      // Tratar especificamente erro 403 (forbidden) - funcionalidade desabilitada
      if (error.response && error.response.status === 403) {
        errors = { 
          desenvolvedor: { 
            mensagem: "Sistema de geração de boletos desabilitado. Entre em contato com seu representante para ativar esta funcionalidade." 
          } 
        };
      } else if (error.response && error.response.data && error.response.data.error) {
        // Usar mensagem de erro do backend se disponível
        errors = { desenvolvedor: { mensagem: error.response.data.error } };
      } else {
        // Fallback para erro genérico
        errors = { desenvolvedor: { mensagem: error.message || "Erro ao gerar boleto" } };
      }
      
      commit(types.SET_BILL_ERROS, errors);
    });
};

export const setBillsPaymentCurrentPage = ({ commit }, page) => {
  commit(types.SET_BILL_PAYMENT_CURRENT_PAGE, page);
};

export const setBillsPaymentLimit = ({ commit }, limit) => {
  commit(types.SET_BILL_PAYMENT_LIMIT, limit);
};

export const setBillsCurrentPage = ({ commit }, page) => {
  commit(types.SET_BILL_CURRENT_PAGE, page);
};

export const setBillsLimit = ({ commit }, limit) => {
  commit(types.SET_BILL_LIMIT, limit);
};

// filters

export const setOrdination = ({ commit }, ordination) => {
  commit(types.SET_FILTER_ORDINATION, ordination);
};

export const setStatus = ({ commit }, status) => {
  commit(types.SET_FILTER_STATUS, status);
};

export const setPayerName = ({ commit }, payerName) => {
  commit(types.SET_FILTER_PAYER_NAME, payerName);
};

// PIX Payment Actions
export const newPixPayment = ({ commit }, pixPayment) => {
  commit(types.LOADING_DATA, true);
  Flowit.wallet
    .newPixPayment(pixPayment)
    .then(response => {
      commit(types.SET_PIX_PAYMENT, response);
      commit(types.LOADING_DATA, false);
    })
    .catch(error => {
      let errorData = {};
      
      // Tratar especificamente erro 403 (forbidden) - funcionalidade desabilitada
      if (error.response && error.response.status === 403) {
        errorData = {
          message: "Sistema de pagamento PIX desabilitado. Entre em contato com seu representante para ativar esta funcionalidade."
        };
      } else if (error.response && error.response.status === 422) {
        // Erro de validação
        if (error.response.data && error.response.data.errors) {
          errorData = error.response.data;
        } else if (error.response.data && error.response.data.error) {
          errorData = { message: error.response.data.error };
        } else {
          errorData = { message: "Dados inválidos. Verifique os campos e tente novamente." };
        }
      } else if (error.response && error.response.data) {
        // Usar dados de erro do backend se disponível
        errorData = error.response.data;
      } else {
        // Fallback para erro genérico
        errorData = {
          message: error.message || "Erro ao processar pagamento PIX"
        };
      }
      
      commit(types.SET_PIX_PAYMENT_ERRORS, errorData);
      commit(types.LOADING_DATA, false);
    });
};

export const loadPixPayments = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  Flowit.wallet.pixPaymentsList(params).then(response => {
    commit(types.SET_PIX_PAYMENT_RESOURCES, response.data.resources);
    commit(types.SET_PIX_PAYMENT_RESOURCES_COUNT, response.data.count);
    commit(types.CURRENT_PAGE, response.data.page);
    commit(types.LIMIT, response.data.limit);
    commit(types.SET_PIX_PAYMENT_LOADING_DATA, false);
  }).catch(error => {
    console.error('Error loading PIX payments:', error);
    commit(types.SET_PIX_PAYMENT_RESOURCES, []);
    commit(types.SET_PIX_PAYMENT_RESOURCES_COUNT, 0);
    commit(types.SET_PIX_PAYMENT_LOADING_DATA, false);
  });
};

export const showPixPayment = ({ commit }, pixPaymentId) => {
  commit(types.LOADING_DATA, true);
  Flowit.wallet.showPixPayment(pixPaymentId).then(response => {
    if (response.status === 200) {
      commit(types.SHOW_PIX_PAYMENT, response.data.pix_payment);
    } else {
      commit(types.SET_PIX_PAYMENT_ERRORS, response.data);
    }
    commit(types.LOADING_DATA, false);
  }).catch(error => {
    commit(types.SET_PIX_PAYMENT_ERRORS, error);
    commit(types.LOADING_DATA, false);
  });
};

export const setAmount = ({ commit }, amount) => {
  commit(types.SET_FILTER_AMOUNT, amount);
};

export const setInitialDate = ({ commit }, date) => {
  commit(types.SET_FILTER_INITIAL_DATE, date);
};

export const setFinalDate = ({ commit }, date) => {
  commit(types.SET_FILTER_FINAL_DATE, date);
};

export const resetFilters = ({ commit }) => {
  commit(
    types.SET_FILTER_INITIAL_DATE,
    moment()
      .startOf("month")
      .format("YYYY-MM-DD")
  );
  commit(
    types.SET_FILTER_FINAL_DATE,
    moment()
      .endOf("month")
      .format("YYYY-MM-DD")
  );
  commit(types.SET_FILTER_ORDINATION, "");
  commit(types.SET_FILTER_STATUS, "");
  commit(types.SET_FILTER_PAYER_NAME, "");
  commit(types.SET_FILTER_AMOUNT, "");
  commit(types.ORDINATION, null);
  commit(
    types.FILTER_INITIAL_DATE,
    moment()
      .startOf("month")
      .format("YYYY-MM-DD")
  );
  commit(
    types.FILTER_FINAL_DATE,
    moment()
      .endOf("month")
      .format("YYYY-MM-DD")
  );
};

export const exportBills = ({ commit }, params) => {
  commit(types.SET_BILL_LOADING_DATA, true);
  return Flowit.wallet.exportBills(params)
    .then(response => {
      commit(types.SET_BILL_LOADING_DATA, false);
      return response;
    })
    .catch(error => {
      commit(types.SET_BILL_LOADING_DATA, false);
      throw error;
    });
};

export const checkExportStatus = ({ commit }) => {
  return Flowit.wallet.checkBillsExportStatus();
};

export const downloadExport = ({ commit }, params) => {
  return Flowit.wallet.downloadBillsExport(params).then(response => {
    if (response.data.download_url) {
      // Create a temporary link and click it to download
      const link = document.createElement('a');
      link.href = response.data.download_url;
      link.download = params.file_name || 'bills_export.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    return response;
  });
};

// DARF Payment Actions
export const newDarfPayment = ({ commit }, darfPayment) => {
  commit(types.LOADING_DATA, true);
  Flowit.wallet
    .newDarfPayment(darfPayment)
    .then(response => {
      commit(types.SET_DARF_PAYMENT, response);
      commit(types.LOADING_DATA, false);
    })
    .catch(error => {
      let errorData = {};
      
      if (error.response && error.response.status === 403) {
        errorData = {
          errors: [{
            response_code: "403",
            response_code_detail: "Sistema de pagamento DARF desabilitado. Entre em contato com seu representante para ativar esta funcionalidade."
          }]
        };
      } else if (error.response && error.response.data) {
        errorData = error.response.data;
      } else {
        errorData = {
          errors: [{
            response_code: "500",
            response_code_detail: error.message || "Erro ao processar pagamento DARF"
          }]
        };
      }
      
      commit(types.SET_DARF_PAYMENT_ERRORS, errorData);
      commit(types.LOADING_DATA, false);
    });
};

export const loadDarfsPayment = ({ commit }, params) => {
  commit(types.LOADING_DATA, true);
  Flowit.wallet.darfsPaymentList(params).then(response => {
    commit(types.SET_DARFS_PAYMENT_RESOURCES, response.data.resources);
    commit(types.SET_DARFS_PAYMENT_RESOURCES_COUNT, response.data.count);
    commit(types.CURRENT_PAGE, response.data.page);
    commit(types.CURRENT_PAGE, response.data.limit);
    commit(types.SET_DARFS_PAYMENT_LOADING_DATA, false);
  });
};

export const loadDarfPayment = ({ commit }, darfId) => {
  console.log('🚀 Action loadDarfPayment called with ID:', darfId);
  commit(types.SET_DARF_PAYMENT_LOADING_DATA, true);
  Flowit.wallet.showDarfPayment(darfId).then(response => {
    console.log('📡 API Response:', response);
    if (response.status === 200) {
      console.log('✅ DARF data received:', response.data.bill_darf);
      commit(types.SHOW_DARF_PAYMENT, response.data.bill_darf);
    } else {
      console.log('❌ API Error:', response.data);
      commit(types.SET_DARF_PAYMENT_ERRORS, response.data);
    }
    commit(types.SET_DARF_PAYMENT_LOADING_DATA, false);
  }).catch(error => {
    console.log('💥 API Exception:', error);
    commit(types.SET_DARF_PAYMENT_ERRORS, error);
    commit(types.SET_DARF_PAYMENT_LOADING_DATA, false);
  });
};

export const setDarfsPaymentLimit = ({ commit }, limit) => {
  commit(types.SET_DARFS_PAYMENT_LIMIT, limit);
};

export const setDarfsPaymentCurrentPage = ({ commit }, page) => {
  commit(types.SET_DARFS_PAYMENT_CURRENT_PAGE, page);
};

// PIX Key Lookup Action
export const lookupPixKey = ({ commit }, pixKey) => {
  return Flowit.wallet
    .lookupPixKey(pixKey)
    .then(response => {
      if (response.status === 200 && response.data.success) {
        return { success: true, data: response.data.data };
      } else {
        return { success: false, error: 'Chave PIX não encontrada' };
      }
    })
    .catch(error => {
      let errorMessage = 'Erro ao consultar chave PIX';
      
      if (error.response && error.response.data && error.response.data.errors) {
        const firstError = error.response.data.errors[0];
        errorMessage = firstError.response_code_detail || errorMessage;
      } else if (error.response && error.response.data && error.response.data.error) {
        errorMessage = error.response.data.error;
      }
      
      return { success: false, error: errorMessage };
    });
};
